var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.59 4.435c1.013 0 1.56.645 1.56 1.363 0 .703-.611 1.133-1.013 1.535-.612.617-1.368 1.55-.982 2.582h.837c.177-.918.836-1.406 1.528-1.965.628-.502 1.48-1.134 1.48-2.31C11 4.22 9.81 3 7.815 3c-1.046 0-1.802.273-2.525.66L5 5.554c.724-.689 1.673-1.12 2.59-1.12M7.67 13c.611 0 1.126-.488 1.126-1.019 0-.545-.514-1.018-1.126-1.018s-1.126.473-1.126 1.018c0 .531.515 1.019 1.126 1.019"
})));
export default SvgHint;